module.exports = __webpack_public_path__ + "7321f31f18e181b9973a153639bedbf5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-scarf-red.png
// module id = 2231
// module chunks = 0